﻿/* globals DescartarInmuebleDTO */
var jquery = require("jquery");
var HabEvents = require("../../Global/habitaclia-events");

(function () {
    "use strict";

    var DescartarInmueble = function (DescartarInmuebleDTO) {
        this._DescartarInmuebleDTO = DescartarInmuebleDTO;
    };

    var __descartarInmueble_Listado = function (InmuebleADescartar) {
		this._DescartarInmuebleDTO.CodEmp = InmuebleADescartar.CodEmp;
		this._DescartarInmuebleDTO.CodOfi = InmuebleADescartar.CodOfi;
		this._DescartarInmuebleDTO.CodInm = InmuebleADescartar.CodInm;
		this._DescartarInmuebleDTO.CodInm = InmuebleADescartar.CodInm;
		this._DescartarInmuebleDTO.IdAnuncio = InmuebleADescartar.IdAnuncio;
		__ajaxCallbackGetSiguienteInmueble.call(this);
    };

    var __recuperarInmueble_Listado = function (InmuebleARecuperar) {
    	this._DescartarInmuebleDTO.CodEmp = InmuebleARecuperar.CodEmp;
    	this._DescartarInmuebleDTO.CodOfi = InmuebleARecuperar.CodOfi;
    	this._DescartarInmuebleDTO.CodInm = InmuebleARecuperar.CodInm;
    	this._DescartarInmuebleDTO.IdAnuncio = InmuebleARecuperar.IdAnuncio;
    	__ajaxRecuperarDescartado.call(this);
    };

    var __descartarInmueble = function () {
    	__callBackDescartarInmueble.call(this);
    };

    var __ajaxCallbackGetSiguienteInmueble = function () {
    	//TODO: controlar temps desde servidor i generar data desde servidor
    	var self = this;
    	jquery.ajax({
    		type: "GET",
    		url: self._DescartarInmuebleDTO.UrlAjaxSiguienteInmueble,
    		data: self._DescartarInmuebleDTO.NavParamsLista,
    		dataType: "json",
    		success: function (data) { __callBackGetSiguienteInmueble.call(self, data); }
    	});
    };

    var __callBackGetSiguienteInmueble = function (data) {
    	var self = this;
    	__callBackDescartarInmueble.call(self);
    	if (data && data !== "" && data !== "{}") {
    		__buildItem.call(this, data);
    	}
    };

    var __ajaxRecuperarDescartado = function () {
    	var inmueble_A_Descartar_RecuperarData = __getDataInmuebleA_Descartar_Recuperar(this._DescartarInmuebleDTO);
    	var self = this;
    	var respuestaAjax = jquery.ajax({
    		type: "POST",
    		url: self._DescartarInmuebleDTO.UrlAjaxRecuperarInmuebleDescartado,
    		data: inmueble_A_Descartar_RecuperarData
    	});

    	respuestaAjax.fail(function () {
    		//trazar error
    	});

    	respuestaAjax.done(function () {
    		__checkInmueblesListado.call(self);
    		jquery.publish(HabEvents.EventsEnum.DoneRecuperarAnuncioDesdeFicha);
        jquery.publish(HabEvents.EventsEnum.DoneRecuperarAnuncioDesdeLista, self._DescartarInmuebleDTO.IdAnuncio);
		});
    };

    var __getDataInmuebleA_Descartar_Recuperar = function (descartarInmuebleDTO) {
        var inmuebleADescartar_Recuperar = {
            CodInm: descartarInmuebleDTO.CodInm,
            CodEmp: descartarInmuebleDTO.CodEmp,
            CodOfi: descartarInmuebleDTO.CodOfi
        };

        return inmuebleADescartar_Recuperar;
    };

    var __callBackDescartarInmueble = function () {
    	var inmueble_A_Descartar_RecuperarData = __getDataInmuebleA_Descartar_Recuperar(this._DescartarInmuebleDTO);
    	var self = this;
    	var respuestaAjax = jquery.ajax({
    		type: "POST",
    		url: self._DescartarInmuebleDTO.UrlAjaxDescartarInmueble,
    		data: inmueble_A_Descartar_RecuperarData
    	});

    	respuestaAjax.fail(function () {
    		//trazar error
    	});

    	respuestaAjax.done(function () {
    		jquery.publish(HabEvents.EventsEnum.DoneDescartarAnuncioDesdeFicha);
        jquery.publish(HabEvents.EventsEnum.DoneDescartarAnuncioDesdeLista, self._DescartarInmuebleDTO.IdAnuncio);
        jquery.publish(HabEvents.EventsEnum.AdDiscardedSuccess, self._DescartarInmuebleDTO.IdAnuncio);
		});
    };

	var __buildItem = function (data) {
		var $newItem = jquery('#tempNewItem').clone();
		var newItemId = 'id'+ data.CodigoAnuncio;
		$newItem.attr('id', newItemId);
		$newItem.addClass('gtmlistproductview');
		$newItem.addClass('gtmproductclick');
		$newItem.addClass('f'+newItemId);
		$newItem.find('.descartarLI').attr('data-idanuncio', newItemId);
		$newItem.find('.descartarLI').attr('data-descartar', data.CodInm+'-'+data.CodEmp+'-'+data.CodOfi);
		$newItem.find('.favoritoLI').attr('data-favorito', 'fav'+data.CodigoAnuncio);
		$newItem.find('#tempNewItemId').attr('id', data.CodigoAnuncio);
		$newItem.find('#tempMenuSpan').attr('id', 'menuSpan'+data.CodigoAnuncio);
		$newItem.find('#tempMenuUl').attr('id', 'menuUl'+data.CodigoAnuncio);
		$newItem.find('.recuperar-anuncio').attr('data-recuperar', data.CodInm+'-'+data.CodEmp+'-'+data.CodOfi);
		$newItem.find('.recuperar-anuncio').attr('data-idanuncio', newItemId);
		if(data.EsDestacado){
			$newItem.find('.temp-favorito').addClass('destacado');
			$newItem.addClass('destacado');
		}
		if(data.TieneMultimedia){
			if(data.ContImg>0){
				$newItem.find('.foto-listado').text(data.ContImg);
				$newItem.find('#tempIdPswp').css('background-image', 'url('+data.ImagenPrincipal.UrlImagen+')');
				$newItem.find('#tempIdPswp').addClass('imgswipe').addClass('pswp'+data.CodigoAnuncio);

				for(var i = 0; i < data.ListaImagenes.length; i ++){
					var newImage;
					if(i === 0){
						newImage = '<li class="first dragend-page" data-image="'+data.ListaImagenes[i].NomImagen+'" data-imagepos="'+i+'" style="background-image: url('+data.ListaImagenes[i].UrlImagen+');"></li>';
					}else if(i === data.ListaImagenes.length-1){
						newImage = '<li class="last dragend-page" data-image="'+data.ListaImagenes[i].NomImagen+'" data-imagepos="'+i+'" style="background-image: url('+data.ListaImagenes[i].UrlImagen+');"></li>';
					}else{
						newImage = '<li class="dragend-page" data-image="'+data.ListaImagenes[i].NomImagen+'" data-imagepos="'+i+'" style="background-image: url('+data.ListaImagenes[i].UrlImagen+');"></li>';
					}
					$newItem.find('#tempPswpUl').append(newImage);
				}
				$newItem.find('#tempPswpUl').removeAttr('id');
			}else{
				$newItem.find('.foto-listado').remove();
			}
			if(data.ContVideos>0){
				$newItem.find('.video-listado').text(data.ContVideos);
			}else{
				$newItem.find('.video-listado').remove();
			}
		}else{
			$newItem.find('.multimedia').remove();
			$newItem.find('#tempIdPswp').css('background-image', 'url('+data.ImagenNoDisponible.UrlImagen+')');
		}
		$newItem.find('#tempIdPswp').attr('id', 'pswp'+data.CodigoAnuncio);
		if(!data.EsObraNueva){
			$newItem.find('.obra-nueva-item').remove();
		}
		if(!data.EsOportunidad){
			$newItem.find('.oportunidad').remove();
		}
		if(!data.EsPremium){
			$newItem.find('.temp-premium').remove();
		}
		if(!data.EsPremiumPlus){
			$newItem.find('.temp-premium-plus').remove();
		}

		if(data.TienePrecio){
			$newItem.find('.temp-consultar-precio').remove();
			if(!data.EsPromocion){
				$newItem.find('.temp-promo-precio').remove();
				$newItem.find('.temp-precio').text(data.Precio);
				$newItem.find('.temp-precio').addClass('precio');
			}else{
				$newItem.find('.temp-precio').remove();
				$newItem.find('.temp-promo-precio span').text(data.Precio);
				$newItem.find('.temp-promo-precio').addClass('precio');
			}
		}else{
			$newItem.find('.temp-promo-precio').remove();
			$newItem.find('.temp-precio').remove();
			$newItem.find('.temp-consultar-precio').addClass('consultar-precio');
		}
		if(data.HaBajadoDePrecio){
			$newItem.find('.temp-price-down').text(data.DiferenciaPrecio);
		}else{
			$newItem.find('.bajada').remove();
		}
		if(!data.TieneM2){
			$newItem.find('.m2').text(data.M2 +' €');
		}else{
			$newItem.find('.m2').remove();
		}
		if(!data.TieneHabitaciones){
			$newItem.find('.numhab').text(data.Hab +' hab.');
		}else{
			$newItem.find('.numhab').remove();
		}
		if(data.TienePrecioMetroCuadrado){
			var precioMetro = Math.round(data.PrecioMetroCuadrado);
			$newItem.find('.preciom2').html(precioMetro +' €/m<sup>2</sup>');
		}else{
			$newItem.find('.preciom2').remove();
		}
		if(data.MostrarFechaDeModificacion){
			$newItem.find('.fecha-actualizacion-li').text(data.TextoFechaPublicacion);
		}else{
			$newItem.find('.fecha-actualizacion').remove();
		}

		$newItem.find('#tempFavId').attr('href', data.HostConProtocolo+'hab_usuarios/ajax/favoritos.asp'+data.ParametrosUrlFavorito);
		$newItem.find('#tempFavId').addClass('favlink');
		$newItem.find('#tempFavId').addClass('addfavimg');
		$newItem.find('.temp-link-item').attr('href', data.NavigationUrl);
		$newItem.find('.temp-link-item').addClass('link-item');

		$newItem.find('#tempFavId').attr('id', 'fav'+data.CodigoAnuncio);
		if(!data.TieneFavorito){
			$newItem.find('.temp-favorito').addClass('favorito');
			var favclasses = data.FavoritoGetClass_Action +' favlink';
			$newItem.find('.temp-favlink').addClass(favclasses);
		}

		$newItem.find('h2').text(data.TituloFicha);
		$newItem.find('h5').text(data.DescripcionUbicacion);

		//TODO show minimenu
		//TODO for pswp photos

		$newItem.attr('style', '');
		$newItem.appendTo('#lista-resultados > ul');

		__bindNewItem.call(this, newItemId);
	};

	var __bindNewItem = function (newItemId) {
		jquery.publish(HabEvents.EventsEnum.NewItemAfterDiscard, newItemId);
	};

	var __checkInmueblesListado = function(){
		var $visibleItems = jquery('ul:not(.topNlistado):not(.lista-ady) .gtmlistproductview:not(.anuncio-descartado-listado)');
		if($visibleItems.length >= 15){
			$visibleItems.last().remove();
		}
	};

    DescartarInmueble.prototype = {
    	constructor: DescartarInmueble,
    	DescartarInmueble: __descartarInmueble,
    	RecuperarDescartado: __ajaxRecuperarDescartado,
    	DescartarInmueble_Con_Parametro: __descartarInmueble_Listado,
    	RecuperarInmueble_Con_Parametro: __recuperarInmueble_Listado
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = new DescartarInmueble(DescartarInmuebleDTO);
    }
    else {
        window.DescartarInmueble = DescartarInmueble;
    }

}());